import React from 'react'
import Modal from '../../../../common/modal/Modal'
// import UserInfo from './UserInfo'
import { modalManageLicenseId } from '../Licenses/Utils'

const ModalManageLicense = () => {

  return (
    <>
      <Modal
        modalId={ modalManageLicenseId }
        buttonTitle={''}
        modalHeading={'Manage License'}
        modalClassNames={'msync-members-custom-modal msync-members-custom-modal-border'}
      >
        <main className="msync-modal__body">
          {/* <div className='msync-member-manage-user'>
            <UserInfo modalId={ modalManageUserId } />
          </div> */}
        </main>
      </Modal>
    </>
  )
}

export default ModalManageLicense
